import React from 'react'
import {
    Form,
  Input,
  TextArea,
  Toast,
  Button,ImageUploader,Ellipsis,List,Picker,Modal,Dialog,NavBar,Switch,Radio,Space
} from 'antd-mobile-v5';
import dayjs from 'dayjs'
import { MessageOutline, SetOutline,RightOutline } from 'antd-mobile-icons'
import BottomMenu from '../../comronent/BottomMenu/index';
import '../../assets/font/font.css'

import '../PostsSeting/index.css'
import { useNavigate } from 'react-router-dom';

const withNavigate = (WrappedComponent) => {
    return (props) => {
        const navigate = useNavigate();
        return <WrappedComponent {...props} navigate={navigate} />;
    };
};

class Index extends React.Component {

    constructor(props) {
        super(props);

        this.state = {

        };
    }

    componentDidMount() {


    }


    render() {

        return (
            <div style={{ height: "100%", width: "100%", overflow: "auto" }}>

                <NavBar back='返回' onBack={() => {
                    this.props.navigate('/seting', { replace: true, state: { from: 'home' } }); // 传递状态
                }}>
                    跟帖设置
                </NavBar>

                <div style={{
                    height: "85%", backgroundColor: "rgb(227 227 227)"
                }}>

                    <div className="setting" style={{ paddingTop: "10px" }}>
                        <List mode='card' header=''>
                            <List.Item extra={
                                <div style={{ width: "150px", display: "flex", justifyContent: "flex-end" }}>
                                    <Radio.Group value='2'
                                        onChange={val => {
                                            Toast.show({
                                                content: '暂未开放，敬请期待！'
                                            })
                                        }}>
                                        <Space direction='horizontal'>
                                            <Radio value='1'>是</Radio>
                                            <Radio value='2' style={{ marginLeft: "15px", marginRight: "10px" }}>否</Radio>
                                        </Space>
                                    </Radio.Group>
                                </div>
                            }>
                                匿名跟帖
                            </List.Item>
                        </List>
                    </div>

                </div>


                <BottomMenu position="absolute" selectKey="my" />

            </div>
        )
    }
}

export default withNavigate(Index);